import { render, staticRenderFns } from "./Aside.vue?vue&type=template&id=61f33cd4"
import script from "./Aside.vue?vue&type=script&lang=js"
export * from "./Aside.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/dem/Go/src/github.com/demget/quadroclub/web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('61f33cd4', component.options)
    } else {
      api.reload('61f33cd4', component.options)
    }
    module.hot.accept("./Aside.vue?vue&type=template&id=61f33cd4", function () {
      api.rerender('61f33cd4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "site/src/components/Aside.vue"
export default component.exports